/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hostpublishtitle2Inputs */

const en_hostpublishtitle2 = /** @type {(inputs: Hostpublishtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publish the profile too?`)
};

const de_hostpublishtitle2 = /** @type {(inputs: Hostpublishtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil auch veröffentlichen?`)
};

/**
* | output |
* | --- |
* | "Publish the profile too?" |
*
* @param {Hostpublishtitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const hostpublishtitle2 = /** @type {((inputs?: Hostpublishtitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hostpublishtitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_hostpublishtitle2(inputs)
	return de_hostpublishtitle2(inputs)
});
export { hostpublishtitle2 as "hostPublishTitle" }